import axios from 'axios'
import {getAdminToken} from '../../auth/_requests'

const API_URL = process.env.REACT_APP_API_URL

const adminApi = axios.create({
  withCredentials: true,
  validateStatus: (status) => (status >= 200 && status < 300) || status === 304
})

adminApi.interceptors.request.use((config) => {
  const token = getAdminToken()
  if (token && config.headers) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

export interface ScheduledChild {
  _id: string
  name: string
  facebook_id: string
  is_online: boolean
  posts_per_day: number
  post_count: number
  campaign_count: number
}

export interface ScheduledParent {
  parent_id: string
  parent_name: string
  parent_facebook_id: string
  parent_is_online: boolean
  parent_is_scheduled: boolean
  parent_post_count: number
  account_id: string
  account_name: string
  account_email: string
  account_company: string
  account_locked: boolean
  scheduled_children_count: number
  children: ScheduledChild[]
}

export interface ScheduledSubprofileSummary {
  total_active_children: number
  total_scheduled_children: number
  total_parents_with_scheduled: number
}

export interface ParentCommand {
  parent_id: string
  parent_name: string
  children_count?: number
  account_id: string
  account_email: string
}

export interface ScheduledSubprofileStatsResponse {
  success: boolean
  date: string
  summary: ScheduledSubprofileSummary
  parents: ScheduledParent[]
  commands: {
    scheduled: ParentCommand[]
    not_scheduled: ParentCommand[]
  }
}

export function getScheduledSubprofileStats(): Promise<{data: ScheduledSubprofileStatsResponse}> {
  return adminApi.get(`${API_URL}/admin/scheduled-subprofiles/stats`)
}
